import React from 'react';
import {LinkContainer, ActiveLink} from './styles';

export default ({title, path, recursivePath}: {title: string; path: string; recursivePath?: string}) => (
  <LinkContainer>
    <ActiveLink
      to={path}
      style={
        window.location.href.includes(recursivePath as string)
          ? {
              color: '#000000',
              fontWeight: 'bold',
              borderBottom: 'var(--PrimaryRed) 3px solid',
            }
          : {}
      }
      activeStyle={{
        color: '#000000',
        fontWeight: 'bold',
        borderBottom: 'var(--PrimaryRed) 3px solid',
      }}>
      {title}
    </ActiveLink>
  </LinkContainer>
);
